module.exports = __webpack_public_path__ + "img/2019112003.38945f56.jpg";